import { numberRoundDownWithDecimals } from '@betterment/shared-components';

import { PurposeEmergencyFund } from '../../../data';

type Props = {
  purpose: PurposeEmergencyFund;
};

export const EmergencyFundHeader = ({ purpose }: Props) => {
  const monthsCovered = numberRoundDownWithDecimals(purpose.monthsExpensesCovered, 1);

  return `Your current balance can cover ${monthsCovered} months of expenses.`;
};
